<script>
    import { createEventDispatcher } from 'svelte'
    import BigIcon from '../../components/Icons/BigIcon.svelte'
    // import SearchQuery from '../../components/SearchQuery/SearchQuery.svelte'
    import ClientsSideLinks from './ClientsSideLinks.svelte'
    import SidepanelButton from '../../components/SidepanelLink/SidepanelButton.svelte'

    export let client = null

    const dispatch = createEventDispatcher ();
</script>

<style>
    .SidepanelContent {
        padding: 25px 20px 20px 20px;
    }
    .SidepanelContent .icon-holder {
        text-align: center;
        margin-bottom: 10px;
    }
    .SidepanelContent .meta {
        text-align: center;
        margin-bottom: 20px;
    }
    .SidepanelContent .meta .label {
        font-size: 18px;
        font-weight: 600;
        line-height: 20px;
    }
    .SidepanelContent .meta .text {
        font-size: 13px;
        color: var(--text-secondary);
        line-height: 14px;
    }
</style>

<div class="SidepanelContent">
    <div class="icon-holder">
        <BigIcon icon="fad fa-bell-on" />
    </div>
    {#if client}
        <div class="meta">
            <div class="label">{client.name}</div>
            <div class="text">Regole periodiche cliente</div>
        </div>
        <div class="links">
            <ClientsSideLinks clientId={client.id} />
            <SidepanelButton on:click={e => dispatch ('create')} >
                Crea nuova regola
            </SidepanelButton>
        </div>
        <!-- <div class="search">
            <SearchQuery on:search />
        </div> -->
    {/if}
</div>